


// ***********************************  Please don't change file name for dark mode (use in _app.js) ******************************************

import React, { Component } from "react";
import { bindActionCreators } from "redux";
import withRedux from "next-redux-wrapper";
import withReduxSaga from "next-redux-saga";
import Head from "next/head";
import PropTypes from "prop-types";
import Store from "store";
import {
    fetchVideos
} from "store/posts/actions";
import NProgress from "components/NProgress";
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { Router, Link } from "routes";
import {
  isMobile,
  isBrowser
} from "react-device-detect";
import Icon from '@material-ui/core/Icon';
import TagManager from 'react-gtm-module';
import Hidden from '@material-ui/core/Hidden';
import ContentTitle from "/components/contentTitle";
import DesktopVideoCards from "/components/Video/DesktopVideoCards";
import MobileVideoCards from "/components/Video/MobileVideoCards";
import Button from '@material-ui/core/Button';
import Axios from "/plugins/axios";
import ThereIsNoItem from '/components/thereIsNoItem';
import SeoMeta from '/components/seoMeta';
import {getFooterTopOffset, infiniteHandleScroll} from '/components/NextMore/infiniteHandleScroll';
import {c} from '/utils/log';
import { duwunCoverLogo } from '/utils/common';

const tagManagerArgs = {
    // gtmId: 'GTM-WCJSTPT',
    dataLayer: {
        userId: '001',
        userProject: 'project',
        Section: 'Section',
    }
}

const styles = theme => ({
  root: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      overflow: 'hidden',
  }
});
class Videos extends Component {

  constructor(props){
    super(props);
    this.state = {
        newsItems: [],
        loading: false,
        next: this.props.links.next,
        url: this.props.url,
    }
    this.handleScroll = infiniteHandleScroll.bind(this, this);
    // this.handleScroll = this.handleScroll.bind(this);
  }

    static getInitialProps({ store, asPath }) {
        const currentDateTime = new Date().toISOString();
        const type = asPath.includes("/tv/") || asPath.includes("/tv") ? 'TV' : 'TV,VIDEO';
        store.dispatch(fetchVideos(currentDateTime, type, 8));
        return {currentDateTime, type}
    }

    static getDerivedStateFromProps(nextProps, prevState){
        if(prevState.url.query !== nextProps.url.query){
            return ({
                next: nextProps.links.next,
                newsItems:[], // next item remove from prev route when route change
                // next: `/categories/${ nextProps.url.query.category }?page=2`,// when next is null, next_btn disappear. But when route change, next is [1,2,3,4,5], next_btn still disappear.So this way has been resolved for this error.
            })
        }
        return {};

    }
    nextPage = (url) => {
        // const nextPerPage = isMobile ? 6 : 8

        url = `/videos/latest?type=${this.props.type}&published_date=${this.props.currentDateTime}&perPage=${8}&exclude=body${  url.split('?').length > 0 ? `&${  url.split('?')[1]}` : ''}`;
        c.log("nextURL: ", url);
        c.log("nextPage:this.setState({loading:true})");
        this.setState({
            loading: true
        });

        Axios.get(url)
            .then(res => {
                res.data.data.map((value) => this.state.newsItems.push(value))
                c.log("nextPage:Axios:success:this.setState({newsItems:...})");
                this.setState({
                    newsItems: this.state.newsItems,
                    next: res.data.links.next,
                    url: this.props.url,
                    loading: false,

                })

            })
    }

    __nextBtn () {
        const {classes, uniReadable} = this.props;
        if(this.state.next != null) {
            return (
              <div className="next_more_btn_gtm" style={{textAlign: 'center', padding: '20px 0px'}}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  style={{boxShadow: 'none', fontWeight: 'bold', borderRadius: 50}}
                  onClick={() => !this.state.loading ? this.nextPage(this.state.next) : null}
                >
                  <span>
                    {
                        uniReadable ? 'နောက်ထပ်':  'ေနာက္ထပ္'
                    }
                  </span>
                  {this.state.loading ?
                    <div className="ld ld-ring ld-spin" style={{marginLeft: 5, marginRight: 5}} />
                        :
                    <div style={{display: 'inline-flex'}}>
                      <Icon>keyboard_arrow_down</Icon>
                    </div>
                     }
                </Button>
              </div>
            )
        }
    }

render() {
    const { links, classes, videos, categoriesStore, metaTag } = this.props;
    const { newsItems } =this.state;
    // let videosPlaylist = videos.filter(item => item.playlist_id)
    let videoFilterObj = categoriesStore && categoriesStore.filter(item => item.slug === 'videos')
    // let tvFilterObj = categoriesStore && categoriesStore.filter(item => item.slug === 'tv')
    let videoOgImage = videoFilterObj && videoFilterObj.length !== 0 && videoFilterObj[0].cover.social ? videoFilterObj[0].cover.social : duwunCoverLogo
    // let tvOgImage = tvFilterObj && tvFilterObj.length !== 0 && tvFilterObj[0].cover.social ? tvFilterObj[0].cover.social : duwunCoverLogo
    let categoryThemeColor = videoFilterObj && videoFilterObj[0] && videoFilterObj[0].color
    // this.props.type === 'VIDEO' ? videoFilterObj[0].color : tvFilterObj[0].color;
    let categorySection = videoFilterObj && videoFilterObj[0] && videoFilterObj[0].name
    // this.props.type === 'VIDEO' ? videoFilterObj[0].name : tvFilterObj[0].name;
    return (
      <div>
        <Head>
          <title>Duwun {this.props.type === 'TV' ? 'Tv' : 'Videos' }</title>
        </Head>
        <SeoMeta
            url={`${process.env.BACKEND_URL}${this.props.url.asPath}`}
            type="video.other"
            title={`Duwun ${this.props.type === 'TV' ? 'TV' : 'Videos'}`}
            description={metaTag && metaTag.description}
            image={videoOgImage}
              // this.props.type === 'VIDEO' ? videoOgImage : tvOgImage }
            themeColor={categoryThemeColor}
            section={metaTag && metaTag.section ? metaTag.section : categorySection}
            keywords={metaTag && metaTag.keywords ? metaTag.keywords : this.props.type}
          />        
        <NProgress />

        <Hidden only={['md', 'lg', 'xl']}>
            <div style={{padding: '20px 10px 10px'}}>
                <ContentTitle contentTitle={this.props.type === 'TV' ? 'TV' : 'Videos'} color="#fff" typoComponent="h1" />
            </div>
            {
                videos && videos.length === 0 ?
                <ThereIsNoItem thereIsNoItem="There is no video." /> :
                // <div>sd</div>
                <MobileVideoCards items={videos} newsItems={newsItems.length > 0 ? newsItems: null} />

            }
             { links.next ?  this.__nextBtn() : null}
        </Hidden>
        <Hidden smDown>
            <div className={classes.root}>
                <div className='layout'>
                    <ContentTitle contentTitle={this.props.type === 'TV' ? 'TV' : 'Videos'} color="#fff" typoComponent="h1" />
                    {
                         videos && videos.length === 0 ?
                        <ThereIsNoItem thereIsNoItem="There is no video." /> :
                        <DesktopVideoCards items={videos} newsItems={newsItems.length > 0 ? newsItems: null} />
                    }
                     { links.next ?  this.__nextBtn() : null}
                </div>
            </div>
        </Hidden>
      </div>
    );
  }
    componentDidMount () {
        c.log("video.js::componentDidMount()");

        this.setState({
            ssrDone: true,
        });        

        setTimeout(() => {
            this.previousFooterTopOffset = getFooterTopOffset();
            c.log("video.js:componentDidMount:previousFooterTopOffset:Timeout:500");
            c.log(this.previousFooterTopOffset, "vs", this.newFooterTopOffset);
            window.addEventListener('scroll', this.handleScroll);
        },500);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    // handleScroll(event) {
    //     // console.log("handleScroll > event:");
    //     // console.log(event);
    //     // console.log("handleScroll > that:");
    //     // console.log(that);
    //     if(window.pageYOffset > 200 && !this.state.pageFiveLoaded) {
    //       if(this.state.next != null && !this.state.loading) {
    //         this.nextPage(this.state.next);
    //       }
    //       let nextApi = this.state.next;
    //       let endInfiniteScroll = nextApi != null && nextApi.includes("page=5");
    //       if(endInfiniteScroll){
    //         this.setState({pageFiveLoaded: true})
    //       }
    //     }
    // }

    componentDidUpdate(previousProps, previousState){
        c.log("video.js::componentDidUpdate()");
        tagManagerArgs.dataLayer.Section = 'videos';
        TagManager.dataLayer(tagManagerArgs)

        let nextPage = this.state.next != null && this.state.next.split('?').length > 0 ? this.state.next.split('?')[1] : '';
        this.nextPageNumber = nextPage.split('page=').length > 0 ? parseInt(nextPage.split('page=')[1]) : 2;

        {/* ***** showMore and infiniteScroll Events ***** */}
        if(this.state.ssrDone && !this.state.loading) {
            const currentPageNumber = this.nextPageNumber ? this.nextPageNumber-1 : 0;
            const pageUrl = document.location.origin + document.location.pathname;
            const showMorePagePath = currentPageNumber <= 1 ? pageUrl : pageUrl + "#page-" + currentPageNumber;  
            if(currentPageNumber > 1) {  
                window.parent.location.hash = "page-" + currentPageNumber;
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'showMoreEvent',
                    showMoreEventPage: showMorePagePath,
                    showMoreEventTitle: this.props.type && this.props.type === 'TV' ? 'Tv' : 'Videos'
                });                
            }
        }

        if(previousProps.url.query!= this.props.url.query) {
            this.initialPageLoaded = false;
            this.nextPageNumber = 2;
        }
        setTimeout(() => {
            this.newFooterTopOffset = getFooterTopOffset();
            c.log("video.js:componentDidUpdate:newFooterTopOffset:Timeout:500");
            c.log(this.previousFooterTopOffset, "vs", this.newFooterTopOffset);
        },500);
    }
}
Videos.propTypes = {
  classes: PropTypes.object.isRequired,
  videos: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const mapStateToProps = state => ({
  links: state.posts.videos.links,
  videos: state.posts.videos.data,
  metaTag: state.posts.videos && state.posts.videos.metaTag || null
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchVideos
    },
    dispatch
  );

export default withRedux(Store, mapStateToProps, mapDispatchToProps)(
  withReduxSaga(withStyles(styles)(Videos))
);
